import styled, {css} from 'styled-components';
import {tokensForThemeProvider} from '@forecast-it/design-system';

const tokens = tokensForThemeProvider.sky.sys;

// The design-system Button is always 44px tall. The Studio's denser controls need two smaller sizes:
// `header` (32px) for a collapsible section's toggle, and `row` (28px, detail type) for buttons repeated
// down a list. Wrapping the Button keeps its colours, icons, focus ring and press handling; only its
// height, minimum width, padding, outer margin and, for `row`, type are changed.
export type NovaButtonSize = 'header' | 'row';

const HEIGHT: Record<NovaButtonSize, string> = {
	header: '32px',
	row: '28px',
};

export const NovaButtonSizer = styled.span<{$size: NovaButtonSize}>`
	display: inline-flex;
	min-width: 0;

	& button {
		height: ${({$size}) => HEIGHT[$size]};
		min-width: 0;
		margin: 0;
		padding: 0 ${tokens.spacing['200']};
		${({$size}) =>
			$size === 'row' &&
			css`
				${tokens.font.detail['1']}
				font-weight: 500;
			`}
	}
`;
